import { Button } from '@brightdrop/bd-ui';
import { useTranslations } from '@brightdrop/localization-client';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '~/app/store';
import { FLEET_NOTIFICATIONS_LIST } from '~/common/models/pages/fleetPages.model';
import { NOTIFICATION_SETTINGS_MESSAGES } from '~/routes/settings/settings.messages';
import { setPopUp } from '~/store/alerts/alertsSlice';

import { useStyles } from './SeeAllButton.styles';

const SeeAllButton = (props: { variant?: 'secondary' | 'tertiary' }) => {
  const { variant = 'secondary' } = props;

  const { translations } = useTranslations(NOTIFICATION_SETTINGS_MESSAGES);
  const { classes } = useStyles();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  return (
    <Box className={classes['rt--notifications--cmp--buttons--see-all-box']}>
      <span
        className={
          classes['rt--notifications--cmp--buttons--see-all-button-container']
        }
      >
        <Button
          data-testid="see-all-button"
          variant={variant}
          onClick={() => {
            dispatch(setPopUp(false));
            navigate(FLEET_NOTIFICATIONS_LIST);
          }}
          width="auto"
        >
          {translations['settings:notifications.seeAllNotifications']}
        </Button>
      </span>
    </Box>
  );
};

export default SeeAllButton;
